var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.canChangeDeliverableType
    ? _c("div", { staticClass: "data-items", class: _vm.classNames }, [
        _c("span", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.deliverableTypeTitle(
                  _vm.deliverable.deliverable_template_id
                ) || "Unknown Type"
              ) +
              "\n    "
          )
        ])
      ])
    : _c(
        "div",
        {
          staticClass: "data-items deliverable-type-link",
          class: _vm.classNames,
          attrs: { "data-toggle": "dropdown" }
        },
        [
          _c("span", [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.deliverableTypeTitle(
                    _vm.deliverable.deliverable_template_id
                  ) || "Unknown Type"
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu" },
            _vm._l(_vm.deliverableTypes, function(type, i) {
              return _c(
                "a",
                {
                  key: i,
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changeDeliverableType(_vm.deliverable, type)
                    }
                  }
                },
                [_vm._v(_vm._s(type.name))]
              )
            }),
            0
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }